import React, { useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
	Row,
	Col,
	Button,
	Form,
	ListGroup,
	InputGroup,
	Toast,
	Tabs,
	Tab,
} from 'react-bootstrap';
import 'react-datetime/css/react-datetime.css';
import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import {
	addSupplier,
	setError,
	setLoading,
} from '../../store/actions/dashboardAction';

const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 2rem 0;
	min-height: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const Box = styled.div`
.nav-tabs .nav-link {
  color: #b2b2b2;

  &.active {
    color: #495057;
    font-weight: 500 !important;
  }
  }
  .open-time{
    padding: 0px !important;  
  }
`;

const SupplierOpeningHours = styled.div`
	.item-list {
		position: relative;

		&.disabled:before {
			content: '';
			width: calc(100% - 26px);
			height: 0;
			border-bottom: 1px solid #000;
			display: block;
			position: absolute;
			top: 20px;
			right: 0;
			z-index: 100;
		}

		.item {
			display: flex;
			gap: 20px;
			align-items: center;
			margin-bottom: 5px;

			.form-group {
				margin-bottom: 0;
				line-height: 1.8rem;
				width: 100%;
				max-width: 120px;

				.form-check-input {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}
				.form-check-label {
					margin-bottom: 0;
					padding-left: 5px;
					font-weight: bold;
					cursor: pointer;
					text-transform: capitalize;
				}
			}
			.input-group {
				p,
				.input-group-text {
					border-left: none;
					font-weight: bold;
				}
			}
		}
	}
`;

function AddSupplier(props) {
	const [passwordNotMatch, setPasswordNotMatch] = useState(false);
	const [receiveEmail, setReceiveEmail] = useState(false);
	const [enableExpress, setEnableExpress] = useState(false);
	const [allowMultiCart, setAllowMultiCart] = useState(false);

	const _passwordInputRef = useRef('');
	const _confirmPasswordInputRef = useRef('');
	const _switchInputReceiveEmailRef = useRef(false);

  const supplierCodeRef = useRef(null);
  const emailRef = useRef(null);
  const email2Ref = useRef(null);
  const firstNameRef = useRef(null);
  const phoneRef = useRef(null);
  const telegramRef = useRef(null);
  const logoRef = useRef(null);
  const deliveryTimeRef = useRef(null);
  const estimateDeliveryTimeRef = useRef(null);
  const addressRef = useRef(null);
  
	// toast states
	const [toastBgColor, setToastBgColor] = useState('bg-success');
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState('Delete successful');

	// toast event
	const handleShowToast = (type) => {
		setShowToast(true);

		if (type === 'SUCCESS') {
			setToastBgColor('bg-success');
			setToastMessage('Operation successful.');
		} else if (type === 'ERROR') {
			setToastBgColor('bg-danger');
			setToastMessage('Operation error.');
		}
	};

	const handleChangeEnableExpress = () => {
		setEnableExpress((prev) => !prev);
	};

	const handleChangeAllowMultiCart = () => {
		setAllowMultiCart((prev) => !prev);
  };
  
  useMemo(() => {
    if (enableExpress === false) {
      setAllowMultiCart(false);
    }
  }, [enableExpress]);

	const handlePasswordChange = () => {
		if (
			_passwordInputRef.current.value !== _confirmPasswordInputRef.current.value
		) {
			setPasswordNotMatch(true);
		} else {
			setPasswordNotMatch(false);
		}
	};

	const handleReceiveEmail = () => {
		if (_switchInputReceiveEmailRef.current.checked) {
			setReceiveEmail(true);
		} else {
			setReceiveEmail(false);
		}
	};

	class OpeningHour {
		constructor({ is_available, day, start_time, end_time }) {
			this.is_available = is_available;
			this.day = day;
			this.start_time = start_time;
			this.end_time = end_time;
		}
	}

	const dayList = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];

	const openingHourListExpress = [
		new OpeningHour({
			is_available: 1,
			day: '1',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '2',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '3',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '4',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '5',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '6',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
		new OpeningHour({
			is_available: 1,
			day: '0',
			start_time: '08:00:00',
			end_time: '18:00:00',
		}),
  ];

  const openingHourListNormal = [
	new OpeningHour({
		is_available: 1,
		day: '1',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '2',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '3',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '4',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '5',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '6',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
	new OpeningHour({
		is_available: 1,
		day: '0',
		start_time: '10:00:00',
		end_time: '21:00:00',
	}),
];

	const [openingHoursExpress, setOpeningHoursExpress] = useState(openingHourListExpress);
	const [openingHoursNormal, setOpeningHoursNormal] = useState(openingHourListNormal);
	const [typeShop, setTypeShop] = useState("normal");

	const handleEachOpeningHoursToggle = (e, index) => {
		const isChecked = e.target.checked;

		if (isChecked) {
			if(typeShop === "express"){
				setOpeningHoursExpress((prev) => {
					let newData = [...prev];
					newData[index].is_available = 1;
	
					return newData;
				});
			}else{
				setOpeningHoursNormal((prev) => {
					let newData = [...prev];
					newData[index].is_available = 1;
	
					return newData;
				});
			}
		} else {
			if(typeShop === "express"){
				setOpeningHoursExpress((prev) => {
					let newData = [...prev];
					newData[index].is_available = 0;
	
					return newData;
				});
			}else{
				setOpeningHoursNormal((prev) => {
					let newData = [...prev];
					newData[index].is_available = 0;
	
					return newData;
				});
			}
		}
  };
  
  // const [isChecked, setIsChecked] = useState(true)

	const handleChangeHour = (e, index, type) => {
		const inputVal = e.target.value;
		if (type === 'open') {
			if(typeShop === "express"){
				setOpeningHoursExpress((prev) => {
					let newData = [...prev];
					newData[index].start_time = inputVal;
	
					return newData;
				});
			}else{
				setOpeningHoursNormal((prev) => {
					let newData = [...prev];
					newData[index].start_time = inputVal;
	
					return newData;
				});
			}
		} else if (type === 'close') {
			if(typeShop === "express"){
				setOpeningHoursExpress((prev) => {
					let newData = [...prev];
					newData[index].end_time = inputVal;
	
					return newData;
				});
			}else{
				setOpeningHoursNormal((prev) => {
					let newData = [...prev];
					newData[index].end_time = inputVal;
	
					return newData;
				});
			}
		}
	};

	const openingHoursErrorPattern = [
		false,
		false,
		false,
		false,
		false,
		false,
		false,
	];

	const [openingHoursValidationErrors, setOpeningHoursValidationErrors] =
		useState(openingHoursErrorPattern);

	const checkValidateOpeningHours = (index) => {
		setOpeningHoursValidationErrors((prev) => {
			let newValue = [...prev];
			if(typeShop === "express"){
				newValue[index] =
					openingHoursExpress[index].start_time &&
					openingHoursExpress[index].end_time &&
					openingHoursExpress[index].is_available
						? openingHoursExpress[index].start_time > openingHoursExpress[index].end_time
						: false;
			}else{
				newValue[index] =
					openingHoursNormal[index].start_time &&
					openingHoursNormal[index].end_time &&
					openingHoursNormal[index].is_available
						? openingHoursNormal[index].start_time > openingHoursNormal[index].end_time
						: false;
			}
			return newValue;
		});
	};

	const handleCheckValidateOpeningHours = (index) => {
		checkValidateOpeningHours(index);
	};

	const handleAddSupplier = async (event) => {
		try {
			const form = event.currentTarget;
			const email2Arr = email2Ref.current.value.split(',');
			let emailValid = true;

			if (email2Arr.length) {
				for (let i = 0; i <= email2Arr.length; i++) {
					if (typeof email2Arr[i] !== 'undefined') {
						let email = email2Arr[i].trim();

						if (
							/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
								email
							)
						) {
							emailValid = true;
						} else {
							emailValid = false;
						}
					}
				}
			}

			if (email2Arr.length > 6) {
				document.getElementById('formEmail2').classList.add('is-invalid');
				emailValid = false;
				alert('Maximum email address is 6');
			} else if (!emailValid) {
				document.getElementById('formEmail2').classList.add('is-invalid');
				alert('Invalid email address');
			} else {
				document.getElementById('formEmail2').classList.remove('is-invalid');
			}

			// opening hours validate when all open hour < close hour
			let isValidOpeningHour;
			if(typeShop === "express"){
				isValidOpeningHour = openingHoursExpress.every(
					(x) => (x.is_available && x.start_time <= x.end_time) || !x.is_available
				  );
			}else{
				isValidOpeningHour = openingHoursNormal.every(
					(x) => (x.is_available && x.start_time <= x.end_time) || !x.is_available
				);
			}
      
			if (form.checkValidity() && emailValid && isValidOpeningHour) {
				if (passwordNotMatch) {
					alert('Password and confirm password not match.');
        } else {
					const dataInput = {
						is_manager: 1,
            is_authorised: 1,
            active: 1,
            otp: 0,
            supplier_code: supplierCodeRef.current.value,
						first_name: firstNameRef.current.value,
						email: emailRef.current.value,
						email_2: email2Ref.current.value,
            supplier_logo: logoRef.current.files ? logoRef.current.files[0] : null,
						receive_email: receiveEmail,
            password: _passwordInputRef.current.value,
						phone: phoneRef.current.value,
            telegram: telegramRef.current.value,
						enable_express: enableExpress,
						allow_multi_cart: allowMultiCart,
						delivery_time: deliveryTimeRef.current.value,
						estimate_delivery_minute: estimateDeliveryTimeRef.current.value,
						address: addressRef.current.value,
						express_supplier_open_hours: JSON.stringify(openingHoursExpress),
						normal_supplier_open_hours: JSON.stringify(openingHoursNormal),
          };
          const formData = new FormData();

          for (let key in dataInput) {
            formData.append(key, dataInput[key]);
          }

					props.addSupplier(formData, setShowToast, setToastMessage, setToastBgColor);
				}
			}
		} catch (error) {
			handleShowToast('ERROR');
			console.log('Debug: ', error);
		}
	};

	const handleSwitchTab = (tab) => {
		if (tab === "express-hours") {
			setTypeShop("express");
		} else if (tab === "normal-hours") {
			setTypeShop("normal");
		}else{
			setTypeShop("normal");
		}
	};

	return (
		<HelpPageWrapper>
			<Row>
				<Col sm={11} className='mb-4'>
					<h2>Add Supplier</h2>
				</Col>
			</Row>
			<Row>
				<Col sm={11}>
					<Form autoComplete='false'>
						<Row>
							<Col sm={6}>
								<Form.Group controlId='formName'>
									<Form.Label>Supplier Code</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='text'
											ref={supplierCodeRef}
											placeholder='Supplier Code'
											required
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group controlId='formName'>
									<Form.Label>Name</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='text'
											ref={firstNameRef}
											placeholder='Name'
											required
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group controlId='formEmail'>
									<Form.Label>Email Login </Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='email'
                      ref={emailRef}
											placeholder='Email address'
											required
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group controlId='formEmail2'>
									<Form.Label>Email receiving orders</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='text'
                      ref={email2Ref}
											placeholder='Email order'
											required
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group controlId='checkboxReceiveEmail'>
									<Form.Check
										type='switch'
										ref={_switchInputReceiveEmailRef}
										checked={receiveEmail}
										id='checkboxReceiveEmail'
										label='Will automatically receive order by email'
										onChange={handleReceiveEmail}
									/>
								</Form.Group>
								<Form.Group controlId='formPhone'>
									<Form.Label>Phone number</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
                      type='tel'
											ref={phoneRef}
											placeholder='Phone number'
											required
										/>
									</InputGroup>
								</Form.Group>
								<ListGroup className='mb-3'>
									<ListGroup.Item>
										<Form.Group controlId='formPassword'>
											<Form.Label>Password</Form.Label>
											<InputGroup hasvalidation='true'>
												<Form.Control
													type='password'
													ref={_passwordInputRef}
													autoComplete='off'
													required
													onChange={handlePasswordChange}
													placeholder='Password'
												/>
											</InputGroup>
										</Form.Group>

										<Form.Group controlId='formConfirmPassword'>
											<Form.Label>Confirm password</Form.Label>
											<InputGroup hasvalidation='true'>
												<Form.Control
													type='password'
													autoComplete='off'
													ref={_confirmPasswordInputRef}
													onChange={handlePasswordChange}
													required
													placeholder='Confirm password'
												/>
											</InputGroup>
										</Form.Group>
									</ListGroup.Item>
								</ListGroup>
								<Form.Group controlId='formTelegram'>
									<Form.Label>Telegram</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='text'
											ref={telegramRef}
											placeholder='Telegram'
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group controlId='formLogo'>
									<Form.Label>Logo</Form.Label>
									<InputGroup>
										<Form.Control
											type='file'
                      ref={logoRef}
										/>
									</InputGroup>
								</Form.Group>
							</Col>
							<Col sm={6}>
								<Form.Group>
									<Form.Label>Delivery time:</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='time'
                      ref={deliveryTimeRef}
										/>
									</InputGroup>
								</Form.Group>

								<Form.Group controlId='formEstimateDeliveryTime'>
									<Form.Label>Delivery estimate(minute):</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											type='number'
											ref={estimateDeliveryTimeRef}
											placeholder='00'
										/>
									</InputGroup>
								</Form.Group>

								<Form.Group controlId='formAddress'>
									<Form.Label>Address:</Form.Label>
									<InputGroup hasvalidation='true'>
										<Form.Control
											as='textarea'
                      rows={3}
                      ref={addressRef}
										/>
									</InputGroup>
								</Form.Group>

								<Form.Group controlId='formDeliveryTime'>
									<Form.Label>Express Settings</Form.Label>
									<ListGroup className='mb-3'>
										<ListGroup.Item>
											<Row className='mt-2'>
												<Col sm={6}>Deli Express</Col>
												<Col sm={6}>
													<Tooltip
														title='Click to update express setting'
														placement='top'
														arrow
													>
														{enableExpress ? (
															<Button variant='success' onClick={handleChangeEnableExpress}>
																Active
															</Button>
														) : (
															<Button variant='danger' onClick={handleChangeEnableExpress}>
																Inactive
															</Button>
														)}
													</Tooltip>
												</Col>
											</Row>

											<Row className='mt-2'>
												<Col sm={6}>Deli Express Multi</Col>
												<Col sm={6}>
													<Tooltip
														title='Click to update express setting'
														placement='top'
                            arrow
													>
														{allowMultiCart && enableExpress ? (
															<Button variant='success' disabled={!enableExpress} onClick={handleChangeAllowMultiCart}>
																Active
															</Button>
														) : (
															<Button variant='danger' disabled={!enableExpress} onClick={handleChangeAllowMultiCart}>
																Inactive
															</Button>
														)}
													</Tooltip>
												</Col>
											</Row>
										</ListGroup.Item>
									</ListGroup>
								</Form.Group>

								<Form.Label>Opening hours</Form.Label>
								<Box className='open-time'>
									<Tabs defaultActiveKey={`normal-hours`} onSelect={handleSwitchTab}>
										<Tab eventKey={`normal-hours`} title={`Normal`}>
											<ListGroup className='mb-5'>
												<ListGroup.Item>
													<SupplierOpeningHours>
														<div className='opening-hours'>
															<div className='item-list'>
																<div className='item'>
																	<Form.Group></Form.Group>
																	<InputGroup>
																		<p>Store open:</p>
																	</InputGroup>
																	<InputGroup>
																		<p>Store close:</p>
																	</InputGroup>
																</div>
															</div>

															{openingHoursNormal.map((item, index) => (
																<div key={index} className='item-list'>
																	<div className='item'>
																		<Form.Group
																			controlId={dayList[index].toLowerCase() + 'Checkbox'}
																		>
																			<Form.Check
																				type='checkbox'
																				id={dayList[index]}
																				label={dayList[item.day]}
																				value={item.day}
																				checked={item.is_available === 1 ? true : false}
																				onChange={(e) => handleEachOpeningHoursToggle(e, index)}
																			/>
																		</Form.Group>
																		<InputGroup>
																			<Form.Control
																				size='md'
																				name={dayList[index].toLowerCase() + 'OpeningInput'}
																				type='time'
																				maxLength={5}
																				value={item.start_time}
																				disabled={item.is_available === 0 ? true : false}
																				isInvalid={openingHoursValidationErrors[index]}
																				onBlur={() => handleCheckValidateOpeningHours(index)}
																				onChange={(e) => handleChangeHour(e, index, 'open')}
																			/>
																		</InputGroup>
																		<InputGroup>
																			<Form.Control
																				size='md'
																				type='time'
																				name={dayList[index].toLowerCase() + 'CloseInput'}
																				maxLength={5}
																				value={item.end_time}
																				disabled={item.is_available === 0 ? true : false}
																				isInvalid={openingHoursValidationErrors[index]}
																				onBlur={() => handleCheckValidateOpeningHours(index)}
																				onChange={(e) => handleChangeHour(e, index, 'close')}
																			/>
																		</InputGroup>
																	</div>
																</div>
															))}
														</div>
													</SupplierOpeningHours>
												</ListGroup.Item>
											</ListGroup>
										</Tab>
										<Tab eventKey={`express-hours`} title={`Express`}>
											<ListGroup className='mb-5'>
												<ListGroup.Item>
													<SupplierOpeningHours>
														<div className='opening-hours'>
															<div className='item-list'>
																<div className='item'>
																	<Form.Group></Form.Group>
																	<InputGroup>
																		<p>Store open:</p>
																	</InputGroup>
																	<InputGroup>
																		<p>Store close:</p>
																	</InputGroup>
																</div>
															</div>

															{openingHoursExpress.map((item, index) => (
																<div key={index} className='item-list'>
																	<div className='item'>
																		<Form.Group
																			controlId={dayList[index].toLowerCase() + 'Checkbox'}
																		>
																			<Form.Check
																				type='checkbox'
																				id={dayList[index]}
																				label={dayList[item.day]}
																				value={item.day}
																				checked={item.is_available === 1 ? true : false}
																				onChange={(e) => handleEachOpeningHoursToggle(e, index)}
																			/>
																		</Form.Group>
																		<InputGroup>
																			<Form.Control
																				size='md'
																				name={dayList[index].toLowerCase() + 'OpeningInput'}
																				type='time'
																				maxLength={5}
																				value={item.start_time}
																				disabled={item.is_available === 0 ? true : false}
																				isInvalid={openingHoursValidationErrors[index]}
																				onBlur={() => handleCheckValidateOpeningHours(index)}
																				onChange={(e) => handleChangeHour(e, index, 'open')}
																			/>
																		</InputGroup>
																		<InputGroup>
																			<Form.Control
																				size='md'
																				type='time'
																				name={dayList[index].toLowerCase() + 'CloseInput'}
																				maxLength={5}
																				value={item.end_time}
																				disabled={item.is_available === 0 ? true : false}
																				isInvalid={openingHoursValidationErrors[index]}
																				onBlur={() => handleCheckValidateOpeningHours(index)}
																				onChange={(e) => handleChangeHour(e, index, 'close')}
																			/>
																		</InputGroup>
																	</div>
																</div>
															))}
														</div>
													</SupplierOpeningHours>
												</ListGroup.Item>
											</ListGroup>
										</Tab>
									</Tabs>
								</Box>
							</Col>
						</Row>
						<Col>
							<Button
								variant='primary'
								className='pull-right w-25'
								onClick={handleAddSupplier}
							>
								Add
							</Button>
						</Col>
					</Form>

					<Toast
						className={toastBgColor}
						onClose={() => setShowToast(false)}
						show={showToast}
						delay={3000}
						autohide
						style={{
							position: 'fixed',
							top: 70,
							right: 35,
							zIndex: 1041,
							width: '300px',
						}}
					>
						<Toast.Header>
							<strong className='mr-auto m-3'>{toastMessage}</strong>
						</Toast.Header>
					</Toast>
				</Col>
			</Row>
		</HelpPageWrapper>
	);
}

const mapStateToProps = (state) => {
	return {
		success: state.dashboardReducer.success,
		loading: state.dashboardReducer.loading,
		error_message: state.dashboardReducer.error_message,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addSupplier: (data, setShowToast, setToastMessage, setToastBgColor) => addSupplier(data, setShowToast, setToastMessage, setToastBgColor, dispatch),
		setError: (data) => setError(data, dispatch),
		setLoading: (data) => setLoading(data, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(AddSupplier);
